import { FormContext } from '../../../../utils/context/contextFactory';
import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { FormState } from '../../../../utils/state/types';
import { AddError, createAddErrorAction } from './addError/addError';
import {
  ClearErrorByTypes,
  createClearErrorByTypeAction,
} from './clearErrorByTypes/clearErrorByTypes';
import {
  RemoveErrors,
  createRemoveErrorsAction,
} from './removeError/removeErrors';

export type ErrorHandlers = {
  addError: AddError;
  removeErrors: RemoveErrors;
  clearErrorByTypes: ClearErrorByTypes;
};
export const createFormErrorHandlers = (
  actionFactoryParams: ActionFactoryParams<FormState, FormContext>,
): ErrorHandlers => {
  return {
    addError: createAddErrorAction(actionFactoryParams),
    removeErrors: createRemoveErrorsAction(actionFactoryParams),
    clearErrorByTypes: createClearErrorByTypeAction(actionFactoryParams),
  };
};
